export const environment = {
  production: true,
  apiUrl: 'https://aegis2.anvayatech.com',
  resUrl: 'https://aegis2.anvayatech.com/res',
  reportUrl: 'https://aegis2.anvayatech.com/report.php'
};



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/environments/environment.ts